// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'
import * as R from 'ramda'

import styles from './Input.module.scss'

export const Input = React.forwardRef(
  (
    {
      error,
      fieldClassName,
      id,
      min,
      max,
      name,
      placeholder,
      type = 'text',
      value,
      onBlur,
      onFocus,
      onChange,
      isDisabled = false,
      isReadOnly = false,
      isRequired = false,
    },
    ref,
  ) => (
    <input
      className={cx(styles.input, {
        [fieldClassName]: Boolean(fieldClassName),
        [styles.invalid]: Boolean(error),
      })}
      disabled={isDisabled}
      readOnly={isReadOnly}
      required={isRequired}
      {...(R.includes(type, ['date', 'number']) && { min, max })}
      {...{
        id,
        name,
        placeholder,
        ref,
        type,
        value,
        onBlur,
        onFocus,
        onChange,
      }}
    />
  ),
)

export const ControlledInput = ({
  control,
  error,
  fieldClassName,
  id,
  min,
  max,
  name,
  placeholder,
  type,
  isDisabled,
  isReadOnly,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onFocus, onChange } }) => (
      <Input
        {...{
          error,
          fieldClassName,
          id,
          min,
          max,
          name,
          placeholder,
          ref,
          type,
          value,
          onBlur,
          onFocus,
          onChange,
          isDisabled,
          isReadOnly,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
